module.exports = __webpack_public_path__ + "fonts/Roboto-Light.2382fa8.ttf";